import React, { useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import { alertAudio, successAudio, alertNoise, scanSuccess } from '../../assets/sounds';

const AudioAlert = forwardRef((props, ref) => {
  const fallbackRef = useRef(null);

  useImperativeHandle(ref, () => ({
    playAudio: async (isAlert) => {
      const primary = isAlert ? alertAudio : successAudio;
      const fallback = fallbackRef.current;
      const fallbackSrc = isAlert ? alertNoise : scanSuccess;

      try {
        // Try to play the preloaded and user-unlocked audio
        primary.volume = 1;
        primary.currentTime = 0;
        await primary.play();
      } catch (err) {
        console.warn('Primary audio failed, using fallback:', err);
        if (fallback) {
          fallback.src = fallbackSrc;
          fallback.volume = 1;
          fallback.currentTime = 0;
          fallback.play().catch((err) => {
            console.error('Fallback audio failed:', err);
          });
        }
      }
    },
  }));

  return (
    <audio
      ref={fallbackRef}
      id="silent"
      muted
      autoplay
      playsInline
      preload="auto"
      style={{ display: 'none' }}
    />
  );
});

export default AudioAlert;
